import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import useBaseUsasClubData from '@usas/ui-web/state/clubBase/UseBaseUsasClubData';
import useClubTouchpointData from '../../../state/clubTouchpoints/UseClubTouchpointData';

const useClubTouchpoints = () => {
  const navigate = useNavigate();
  const { baseUsasClubState } = useBaseUsasClubData();
  const { clubTouchpointState, getClubTouchpoints, deleteClubTouchpoint } = useClubTouchpointData();
  const [ uiState, setUiState ] = useState({hasBeenDeleted: false});

  const onAdd = (e) => {
    navigate(NavLinks.CLUB_TOUCHPOINTS_DETAILS);
  }
  
  const onEdit = (e, touchpoint) => {
    if (baseUsasClubState.isObjLoaded === true) {
      navigate(NavLinks.CLUB_TOUCHPOINTS_DETAILS, 
        { state: { 
          usasClubTouchpointId: touchpoint.usasClubTouchpointId, 
          touchpointNote: touchpoint.touchpointNote, 
          touchpointDate: touchpoint.touchpointDate,
          touchpointTypeId: touchpoint.touchpointTypeId,
          touchpointSubjectId: touchpoint.touchpointSubjectId,
          touchpointContactTypeId: touchpoint.touchpointContactTypeId,
          followUpDate: touchpoint.followUpDate,
          staffMemberId: touchpoint.staffMemberId,
          hasCustomerSatisfactionSurvey: touchpoint.hasCustomerSatisfactionSurvey || false
        } 
        });
    }
  }

  const onDelete = (e, usasClubTouchpointId) => {
    if (clubTouchpointState.isArrayLoaded === true) {
      deleteClubTouchpoint(usasClubTouchpointId);
      setUiState({hasBeenDeleted: true});
    }
  }

  useEffect(() => {
    if (uiState.hasBeenDeleted === true && clubTouchpointState.isSaving === false && clubTouchpointState.isArrayLoading === false) {
      setUiState({hasBeenDeleted: false});
      getClubTouchpoints(baseUsasClubState.objData.usasClubId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uiState, clubTouchpointState]);

  useEffect(() => {
    if (baseUsasClubState.isObjLoaded === true) {
      getClubTouchpoints(baseUsasClubState.objData.usasClubId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    baseUsasClubState,
    clubTouchpointState,
    onAdd,
    onEdit,
    onDelete
  }
};

export default useClubTouchpoints;